import React from "react";

import styles from "./styles.module.scss";

interface GroupItemProps {
  children?: React.ReactNode;
  className?: string;
}

const GroupItem: React.FC<GroupItemProps> = ({
  children,
  className,
  ...otherProps
}) => {
  const getClassName = () => {
    const classNames = [className, "group-item", styles.groupItem];
    return classNames.filter(Boolean).join(" "); // .filter(Boolean) removes empty/falsy
  };

  return (
    <div className={getClassName()} {...otherProps}>
      {children}
    </div>
  );
};

export default GroupItem;
